import { useCallback, useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext } from '@shared/styles';
import { API } from '@shared/types/api';

interface Props {
  component: API.AuditCheckboxComponentFragment;
  checked: boolean;
  onChange(newValue: boolean): void;
  isReadOnly?: boolean;
}

/** @deprecated Use AuditCheckboxEditField instead. */
export function WorkflowAuditCheckbox({ checked, component, onChange, isReadOnly }: Props) {
  const colors = useContext(ColorThemeContext);

  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <>
      <View row marginBottom={2}>
        <MBTouchableOpacity onPress={handleChange} disabled={isReadOnly}>
          {checked ? (
            <MBIconV2 name="check-filled" color={colors.accent} />
          ) : (
            <MBIconV2 name="check-task" color={colors.input.borderInactive} />
          )}
        </MBTouchableOpacity>
        <View paddingTop={1.25} flex paddingLeft={1}>
          <Text size="body1">{component?.label}</Text>
        </View>
      </View>
    </>
  );
}
